import {useCallback, useState} from 'react';

import {useAnnotationModeStore} from './AnnotationModeStore';

/**
 * What a region surface is editing: a mark's popover, or a merge awaiting
 * confirmation. Reads as closed once the sync layer has replaced that region's
 * annotations wholesale, since what it was opened against no longer stands.
 */
export function useRegionEdit<T>(): [T | null, (edit: T, regionId: string) => void, () => void] {
  const [open, setOpen] = useState<{edit: T; regionId: string; revision: number} | null>(null);
  const revision = useAnnotationModeStore(
    (state) => state.regionRevisions[open?.regionId ?? ''] ?? 0
  );
  const openEdit = useCallback((edit: T, regionId: string) => {
    const {regionRevisions} = useAnnotationModeStore.getState();
    setOpen({edit, regionId, revision: regionRevisions[regionId] ?? 0});
  }, []);
  const closeEdit = useCallback(() => setOpen(null), []);

  return [open && open.revision === revision ? open.edit : null, openEdit, closeEdit];
}
